import React from "react"
import { graphql } from "gatsby"
import { withPrismicPreview } from "gatsby-plugin-prismic-previews"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { linkResolver } from "utils"

import { Layout } from '../../components/layout/Layout'
import { Seo } from '../../components/seo/Seo'
import { Text } from "../../components/Text/Text"


const ContactUsPage: React.FC = () => {
  const { t } = useTranslation("shared", {
    keyPrefix: "contact_us",
  });

  return (
    <Layout>
      <div className="mx-auto max-w-content-width px-5 md:py-10">
        <div className="max-w-[820px]">
          <Text variant="medium-header">{t("title")}</Text>
          <div className="my-10">
            <div className="mb-10">
              <Text variant="small-subheader">{t("send_us_an_email_at")} <a className="underline" href="mailto:support@joinparachute.com">support@joinparachute.com</a>, {t("chat_us_in_the")} <a className="underline" href="/app/">{t("parachute_app")}</a>, {t("or_browse_our")} <a className="underline" href="https://join-parachute.brainfish.ai/" >{t("faqs")}</a>. {t("team_availability")}</Text>
            </div>
            <div className="mb-10">
              <Text variant="body">{t("for_everything_else")}</Text>
            </div>
            <div className="mb-10">
              <Text variant="body">{t("business_and_partnerships")} <a className="underline" href="mailto:marketing@joinparachute.com">marketing@joinparachute.com</a></Text>
            </div>
            <div className="mb-10">
              <Text variant="body">{t("press")} <a className="underline" href="mailto:press@joinparachute.com">press@joinparachute.com</a></Text>
            </div>
            <div className="mb-10">
              <Text variant="body">{t("careers")} <a className="underline" href="https://globalus241.dayforcehcm.com/CandidatePortal/en-US/parachute">{t("current_openings_here")}</a> {t("or")} <a className="underline" href="mailto:recruiting@joinparachute.com">recruiting@joinparachute.com</a></Text>
            </div>
            <div className="mb-10">
              <Text variant="body">{t("human_resources")} <a className="underline" href="mailto:hr@joinparachute.com">HR@joinparachute.com</a></Text>
            </div>
            <div className="mb-10">
              <Text variant="body">{t("cdcs_competitor_information")} <a className="underline" href="mailto:regulatory@joinparachute.com">regulatory@joinparachute.com</a></Text>
            </div>
            <address className="not-italic mb-10">
              <Text variant="body">
                {t("hq_address")}
              </Text>
              <Text variant="body">
                811 Barton Springs Road
              </Text>
              <Text variant="body">
                Suite 510
              </Text>
              <Text variant="body">
                Austin, TX 78704
              </Text>
            </address>
            <Text variant="body">{t("phone")} (737) 301-2470</Text>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const Head = pageData => {

  return (
    <Seo
      canonicalUrl="https://www.joinparachute.com/contact-us/"
      ogTitle="Contact Us"
      title="Contact Us | Join Parachute"
    />
  )
}


export default withPrismicPreview(ContactUsPage, [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
    linkResolver,
  },
])

export const contactUsPageQuery = graphql`
  query ($language: String! = "en") {
    locales: allLocale(
      filter: { ns: { in: ["shared"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
